import { Style, Icon, Text, Fill, Stroke } from 'ol/style';
import log from '../../logger/log.js'

import img_taxi from './img/taxi.svg';
import img_taxi_min from './img/taxi_min.svg';
import img_taxi_full from './img/taxi_full.svg';
import img_taxi_alarm from './img/taxi_alarm.svg';

let taxi_text_style = new Style({
    text: new Text({
        font: 'bold 14px sans-serif',
        offsetY: -44,
        //fill: new Fill({ color: 'rgb(0,0,0)' }),
        //stroke: new Stroke({ color: 'rgb(255,255,255)', width: 1 }),
        backgroundFill: new Fill({ color: 'rgb(255,255,255)' }),
        padding: [2, 0, 0, 2],
        textAlign: "center",
        justify: "center",
    })
});

let taxi_text_min_style = new Style({
    text: new Text({
        font: 'bold 14px sans-serif',
        offsetY: -36,
        //fill: new Fill({ color: 'rgb(0,0,0)' }),
        //stroke: new Stroke({ color: 'rgb(255,255,255)', width: 1 }),
        backgroundFill: new Fill({ color: 'rgb(255,255,255)' }),
        padding: [2, 0, 0, 2],
        textAlign: "center",
        justify: "center",
    })
});
function get_taxi_styles(img_taxi) {
    let taxi_image_styles = {
        'W': new Style({
            image: new Icon({
                color: "#00FF00",
                anchor: [0.5, 1],
                src: img_taxi
            }),
        }),
        'K': new Style({
            image: new Icon({
                color: "#FF33CC",
                anchor: [0.5, 1],
                src: img_taxi
            })
        }),
        'P': new Style({
            image: new Icon({
                color: "#FFFF00",
                anchor: [0.5, 1],
                src: img_taxi
            })
        }),
        'B': new Style({
            image: new Icon({
                color: "#000000",
                anchor: [0.5, 1],
                src: img_taxi
            })
        }),
        'Z': new Style({
            image: new Icon({
                color: "#FF0000",
                anchor: [0.5, 1],
                src: img_taxi
            })
        }),
        'D': new Style({
            image: new Icon({
                color: "#0000FF",
                anchor: [0.5, 1],
                src: img_taxi
            })
        }),
        'O': new Style({
            image: new Icon({
                color: "#71DCE7",
                anchor: [0.5, 1],
                src: img_taxi
            })
        }),
    };
    return taxi_image_styles;
}

let taxi_image_alarm_style = new Style({
    image: new Icon({
        color: "#ff0000",
        anchor: [0.5, 0.5],
        src: img_taxi_alarm
    })
})

let taxi_image_styles = get_taxi_styles(img_taxi);
let taxi_image_full_styles = get_taxi_styles(img_taxi_full);
let taxi_image_min_styles = get_taxi_styles(img_taxi_min);

function taxi_style_fun(feature)
{
    let taxido = feature.get("taxido");

    if (!(taxido.state in taxi_image_styles) || !taxido.lat || !taxido.lng) {
        feature.set('visible', false);
        return null;
    }

    let text = [];
    text.push(taxido.call_number);
    text.push("12px Arial");
    if (taxido.state == 'K' && taxido.state_zone) {
        text.push("\n");
        text.push("1px sans-serif");
        let desc = "";
        if (taxido.state_nav_point) {
            desc += taxido.state_nav_point;
        }
        else {
            desc += taxido.state_zone;
        }
        desc += " [";
        desc += taxido.state_eta;
        desc += "]";
        text.push(desc);
        text.push("10px Arial");
    }
    let text_style = taxi_text_style.clone();
    text_style.getText().setText(text);

    let taxi_style = taxi_image_styles[taxido.state].clone();

    let zindex = taxido.id;
    text_style.setZIndex(zindex);
    taxi_style.setZIndex(zindex);
    //log.d(taxido.call_number, taxi_style.getZIndex());
    feature.set('visible', true);

    let ret_styles = [taxi_style, text_style];

    if(taxido.alarm)
    {
        let alarm_style = taxi_image_alarm_style.clone();
        alarm_style.setZIndex(zindex-1);
        ret_styles.push(alarm_style)
    }
    return ret_styles
}

function taxi_style_full_fun(feature)
{
    let taxido = feature.get("taxido");

    if (!(taxido.state in taxi_image_full_styles) || !taxido.lat || !taxido.lng) {
        feature.set('visible', false);
        return null;
    }

    let text = [];
    text.push(taxido.call_number);
    text.push("12px Arial");
    if (taxido.state == 'K' && taxido.state_zone) {
        text.push("\n");
        text.push("1px sans-serif");
        let desc = "";
        if (taxido.state_nav_point) {
            desc += taxido.state_nav_point;
        }
        else {
            desc += taxido.state_zone;
        }
        desc += " [";
        desc += taxido.state_eta;
        desc += "]";
        text.push(desc);
        text.push("10px Arial");
    }
    let text_style = taxi_text_style.clone();
    text_style.getText().setText(text);

    let taxi_style = taxi_image_full_styles[taxido.state].clone();

    let zindex = taxido.id;
    text_style.setZIndex(zindex);
    taxi_style.setZIndex(zindex);
    //log.d(taxido.call_number, taxi_style.getZIndex());
    feature.set('visible', true);

    let ret_styles = [taxi_style, text_style];

    if(taxido.alarm)
    {
        let alarm_style = taxi_image_alarm_style.clone();
        alarm_style.setZIndex(zindex-1);
        ret_styles.push(alarm_style)
    }
    return ret_styles
}

function taxi_style_min_fun(feature)
{
    let taxido = feature.get("taxido");

    if (!(taxido.state in taxi_image_min_styles) || !taxido.lat || !taxido.lng) {
        feature.set('visible', false);
        return null;
    }

    let text = [];
    text.push(taxido.call_number);
    text.push("12px Arial");
    let text_style = taxi_text_min_style.clone();
    text_style.getText().setText(text);

    let taxi_style = taxi_image_min_styles[taxido.state].clone();

    let zindex = taxido.id;
    text_style.setZIndex(zindex);
    taxi_style.setZIndex(zindex);
    //log.d(taxido.call_number, taxi_style.getZIndex());
    feature.set('visible', true);

    let ret_styles = [taxi_style, text_style];

    if(taxido.alarm)
    {
        let alarm_style = taxi_image_alarm_style.clone();
        alarm_style.setZIndex(zindex-1);
        ret_styles.push(alarm_style)
    }
    return ret_styles
}

export { taxi_style_fun, taxi_style_min_fun, taxi_style_full_fun };
